import {config} from '../config';

export default {
    getTipsAndTricksSections: () => config.data.tipsAndTricksPage.tipsAndTricksSections,
};
